import { type MessageDescriptor, defineMessages } from '@atlassian/jira-intl';

const messages: {
	minutes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hours: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	days: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	weeks: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	months: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	years: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minutesAgo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hoursAgo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	daysAgo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	weeksAgo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	monthsAgo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	yearsAgo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minutesOverdue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	hoursOverdue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	daysOverdue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	weeksOverdue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	monthsOverdue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	yearsOverdue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelOrIs: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelAndNot: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelTimeUnit: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	labelTimeStatus: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	timeInputLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	minutes: {
		id: 'jql-builder-basic-datetime.time-input.minutes',
		defaultMessage: 'minutes',
		description: 'Dropdown item next to a text box that take a number',
	},
	hours: {
		id: 'jql-builder-basic-datetime.time-input.hours',
		defaultMessage: 'hours',
		description: 'Dropdown item next to a text box that take a number',
	},
	days: {
		id: 'jql-builder-basic-datetime.time-input.days',
		defaultMessage: 'days',
		description: 'Dropdown item next to a text box that take a number',
	},
	weeks: {
		id: 'jql-builder-basic-datetime.time-input.weeks',
		defaultMessage: 'weeks',
		description: 'Dropdown item next to a text box that take a number',
	},
	months: {
		id: 'jql-builder-basic-datetime.time-input.months',
		defaultMessage: 'months',
		description: 'Dropdown item next to a text box that take a number',
	},
	years: {
		id: 'jql-builder-basic-datetime.time-input.years',
		defaultMessage: 'years',
		description: 'Dropdown item next to a text box that take a number',
	},
	minutesAgo: {
		id: 'jql-builder-basic-datetime.time-input.minutes-ago',
		defaultMessage: 'minutes ago',
		description: 'Dropdown item next to a text box that take a number',
	},
	hoursAgo: {
		id: 'jql-builder-basic-datetime.time-input.hours-ago',
		defaultMessage: 'hours ago',
		description: 'Dropdown item next to a text box that take a number',
	},
	daysAgo: {
		id: 'jql-builder-basic-datetime.time-input.days-ago',
		defaultMessage: 'days ago',
		description: 'Dropdown item next to a text box that take a number',
	},
	weeksAgo: {
		id: 'jql-builder-basic-datetime.time-input.weeks-ago',
		defaultMessage: 'weeks ago',
		description: 'Dropdown item next to a text box that take a number',
	},
	monthsAgo: {
		id: 'jql-builder-basic-datetime.time-input.months-ago',
		defaultMessage: 'months ago',
		description: 'Dropdown item next to a text box that take a number',
	},
	yearsAgo: {
		id: 'jql-builder-basic-datetime.time-input.years-ago',
		defaultMessage: 'years ago',
		description: 'Dropdown item next to a text box that take a number',
	},
	minutesOverdue: {
		id: 'jql-builder-basic-datetime.time-input.minutes-overdue',
		defaultMessage: 'minutes overdue',
		description: 'Dropdown item next to a text box that take a number',
	},
	hoursOverdue: {
		id: 'jql-builder-basic-datetime.time-input.hours-overdue',
		defaultMessage: 'hours overdue',
		description: 'Dropdown item next to a text box that take a number',
	},
	daysOverdue: {
		id: 'jql-builder-basic-datetime.time-input.days-overdue',
		defaultMessage: 'days overdue',
		description: 'Dropdown item next to a text box that take a number',
	},
	weeksOverdue: {
		id: 'jql-builder-basic-datetime.time-input.weeks-overdue',
		defaultMessage: 'weeks overdue',
		description: 'Dropdown item next to a text box that take a number',
	},
	monthsOverdue: {
		id: 'jql-builder-basic-datetime.time-input.months-overdue',
		defaultMessage: 'months overdue',
		description: 'Dropdown item next to a text box that take a number',
	},
	yearsOverdue: {
		id: 'jql-builder-basic-datetime.time-input.years-overdue',
		defaultMessage: 'years overdue',
		description: 'Dropdown item next to a text box that take a number',
	},
	labelOrIs: {
		id: 'jql-builder-basic-datetime.time-input.label-or-is',
		defaultMessage: 'or is overdue',
		description: 'Select option label',
	},
	labelAndNot: {
		id: 'jql-builder-basic-datetime.time-input.label-and-not',
		defaultMessage: 'and not overdue',
		description: 'Select option label',
	},
	labelTimeUnit: {
		id: 'jql-builder-basic-datetime.time-input.label-time-unit',
		defaultMessage: 'Select unit of time',
		description:
			'Select a unit of time from the drop down, e.g. options include "minutes", "hours", "days" or "weeks". When combined with time unit input text, it should read e.g. "Due in next 10 minutes"',
	},
	labelTimeStatus: {
		id: 'jql-builder-basic-datetime.time-input.label-time-status',
		defaultMessage: 'Select status',
		description:
			'Select a status from the drop down, e.g. options include "or is overdue", "and not overdue". When combined with a unit of time, it should read e.g. "Due in next 10 minutes and not overdue"',
	},
	timeInputLabel: {
		id: 'jql-builder-basic-datetime.time-input.time-input-label',
		defaultMessage: 'Enter a number of {timeUnit}',
		description:
			'Input a number of time label, and the timeUnit is words such as minutes, hours, days and weeks etc.',
	},
});

export default messages;

// Used to dynamically lookup message descriptors while keeping TS happy.
export const messageLookup: { [key: string]: MessageDescriptor | undefined } = messages;
